module.exports = __webpack_public_path__ + "img/companions.ae1ee6d0.svg";